import { Component, OnInit, Output, EventEmitter, SimpleChanges, OnChanges, Input, AfterViewChecked } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ViewChild, ElementRef } from '@angular/core';

import { AuthService } from './../../../services/auth.service';
import { MemberService } from './../../../rest/api/member.service';
import { HelperService } from './../../../services/helper.service';
import { CountryService } from './../../../rest/api/country.service';


import { DateValidator } from './../../../validator/date-validator';
import { ImageHelper } from './../../../validator/image-helper';
import { ScrollHelper } from './../../../services/scroll-helper.service';
import * as moment from 'moment';
import * as _ from 'lodash';

declare var $: any;
import { DateTimeAdapter, OWL_DATE_TIME_FORMATS, OWL_DATE_TIME_LOCALE } from 'ng-pick-datetime';
import { MomentDateTimeAdapter } from 'ng-pick-datetime-moment';

export const MY_CUSTOM_FORMATS = {
  datePickerInput: 'YYYY-MM-DD'
};

@Component({
  selector: 'app-update-space',
  templateUrl: './update-space.component.html',
  styleUrls: ['./update-space.component.scss'],
  providers: [
    { provide: DateTimeAdapter, useClass: MomentDateTimeAdapter, deps: [OWL_DATE_TIME_LOCALE] },
    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_CUSTOM_FORMATS }
  ]
})
export class UpdateSpaceComponent implements OnInit, OnChanges, AfterViewChecked {
  @ViewChild('countryText') countryText: ElementRef;
  @Input() singleSpaceData;
  @Output() updateSpaceEmit = new EventEmitter();
  @Output() closeUpdateSpaceEmit = new EventEmitter();
  @ViewChild('imageFile') imageFile: ElementRef;
  @ViewChild('audioFile') audioFile: ElementRef;

  @ViewChild('publishedDate') publishedDate: ElementRef;

  accessToken: any;
  updateSpaceForm: FormGroup;

  isSubmitting = false;
  isSubmitted = false;
  imageLoading = false;

  errors = [];
  successMsg: string;
  errorMsg: string;
  loading = true;
  loader = true;

  spaceCategoryData: any;

  urlPattern = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';

  uploadErr: string;
  selectedFile: any;
  imageData: any;
  fileText = '';
  countryData: any;
  filteredCountryData: any;
  selectedCountry: any;

  // Audio
  audioLoader = false;
  audioUploadErr: string;
  selectedAudioFile: any;
  audioData: any;
  audioText = '';

  langShortCode: any;
  spaceConfig = {
    show_address: false,
    show_contact_email: false,
    show_contact_name: false,
    show_contact_phone: false,
    show_external_url: false,
    show_name_summary: false,
    show_published_date: false,
  };
  constructor(
    public router: Router,
    public fb: FormBuilder,
    private authService: AuthService,
    public memberService: MemberService,
    public helperService: HelperService,
    public scrollHelper: ScrollHelper,
    public countryService: CountryService
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
    this.langShortCode = localStorage.getItem('language') ? localStorage.getItem('language') : undefined;
  }

  ngOnInit() {
    this.getSpaceCategory();
    this.getCountryData();
    this.fileText = 'Choose File';
    this.audioText = 'Choose File';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.singleSpaceData.currentValue) {
      this.resetErrorValues();
      this.updateSpaceConfig();
      this.updateSpaceFormInit();
      if (this.singleSpaceData.image !== null) {
        this.imageData = this.singleSpaceData.image;
      }
      if (this.singleSpaceData.audio !== null) {
        this.audioData = this.singleSpaceData.audio;
      }
    }
  }


  getCountryData() {
    this.countryService.getCountryName().subscribe((res: any) => {
      this.countryData = res && res.data ? res.data : [];
      this.filteredCountryData = res && res.data ? res.data : [];
      let country;
      if (this.singleSpaceData && this.singleSpaceData.country_code && this.singleSpaceData.country_code !== '') {
        const userCountryCode = this.singleSpaceData.country_code;
        country = this.countryData ? _.find(this.countryData, { alpha_code: userCountryCode}) : undefined;
      } else {
        country = this.countryData ? _.find(this.countryData, { alpha_code: 'JP' }) : undefined;
      }
      if (country) {
        this.selectedCountry = country;
      } else {
        this.selectedCountry = this.countryData && this.countryData[0] ? this.countryData[0] : undefined;
      }
      this.loader = false;
    }, err => {
      this.countryData = [];
      this.loader = false;
    });
  }

  changeCountry(country) {
    if (this.countryText) {
      this.countryText.nativeElement.value = '';
      this.filteredCountryData = this.countryData;
    }
    this.selectedCountry = country;
  }

  searchCountry(event) {
    if (event.target.value === '') {
      this.filteredCountryData = this.countryData;
    } else {
      this.filteredCountryData = _.filter(this.filteredCountryData, _.flow(
        _.identity,
        _.values,
        _.join,
        _.toLower,
        _.partialRight(_.includes, event.target.value)
      ));
    }
  }

  restrictNumeric(e) {
    let input;
    if (e.metaKey || e.ctrlKey) {
      return true;
    }
    if (e.which === 32) {
     return false;
    }
    if (e.which === 0) {
     return true;
    }
    if (e.which < 33) {
      return true;
    }
    input = String.fromCharCode(e.which);
    return !!/[\d\s]/.test(input);
   }

  getSpaceCategory() {
    if (this.langShortCode) {
      this.memberService.getSpaceCategory({
        Authorization: this.accessToken,
        lang: this.langShortCode
      }).subscribe((response: any) => {
        this.spaceCategoryData = response && response.data ? response.data : [];
      }, err => {
        this.spaceCategoryData = [];
      });
    } else {
      this.memberService.getSpaceCategory({
        Authorization: this.accessToken
      }).subscribe((response: any) => {
        this.spaceCategoryData = response && response.data ? response.data : [];
      }, err => {
        this.spaceCategoryData = [];
      });
    }
  }

  onFileChange(event) {
    this.imageLoading = true;
    this.uploadErr = undefined;
    if (event.target.files.length === 0) { return; }
    this.selectedFile = event.target.files[0] as File;

    const name = this.selectedFile && this.selectedFile.name;
    if (name) {
      this.fileText = name;
    }
    const fileExtension = name.split('.').pop();

    if (ImageHelper.isImageSizeExceeded(this.selectedFile.size)) {
      event.target.value = null;
      this.uploadErr = 'Please upload file less than 10 MB.';
      return;
    }

    if (ImageHelper.isImageTypeValid(fileExtension)) {
      event.target.value = null;
      this.uploadErr = 'Please upload valid file type (i.e jpeg, jpg, png, svg).';
      return;
    }
    this.imageData = undefined;
    this.authService.updateSpaceThumb(this.accessToken, this.selectedFile).subscribe((response: any) => {
      this.imageLoading = false;
      if (response.data && response.data.file) {
        this.updateSpaceForm.controls.image.setValue(response.data.file);
      }
      if (response.data && response.data.url) {
        this.imageData = response.data.url;
      }
    }, err => {
      this.imageLoading = false;
      this.uploadErr = err.error && err.error.error ? err.error.error : 'There was error while uploading your file.';
    });
  }

  onFileAudioChange(event) {
    this.audioLoader = true;
    this.audioUploadErr = undefined;
    if (event.target.files.length === 0) { return; }
    this.selectedAudioFile = event.target.files[0] as File;

    const name = this.selectedAudioFile && this.selectedAudioFile.name;
    if (name) {
      this.audioText = name;
    }

    const fileExtension = name.split('.').pop();

    if (ImageHelper.isAudioSizeExceeded(this.selectedAudioFile.size)) {
      event.target.value = null;
      this.audioUploadErr = 'Please upload file less than 10 MB.';
      return;
    }

    if (ImageHelper.isAudioTypeValid(fileExtension)) {
      event.target.value = null;
      this.audioUploadErr = 'Please upload valid file type (i.e mp3, mpga, wav, ogg, pcm).';
      return;
    }
    this.audioData = undefined;
    this.authService.updateSpaceAudio(this.accessToken, this.selectedAudioFile).subscribe((response: any) => {
      this.audioLoader = false;
      if (response && response.data && response.data.file) {
        this.updateSpaceForm.controls.audio.setValue(response.data.file);
      }
      if (response && response.data && response.data.url) {
        this.audioData = response.data.url;
      }
    }, err => {
      this.audioLoader = false;
      this.audioUploadErr = err.error && err.error.error ? err.error.error : 'There was error while uploading your file.';
    });

  }

  isImageSizeExceeded(imageSize: number) {
    return imageSize > 2000000;
  }

  updateSpaceConfig() {
    this.spaceConfig = {
      show_address: this.singleSpaceData && this.singleSpaceData.config && this.singleSpaceData.config.show_address ? this.singleSpaceData.config.show_address : false,
      show_contact_email: this.singleSpaceData && this.singleSpaceData.config && this.singleSpaceData.config.show_contact_email ? this.singleSpaceData.config.show_contact_email : false,
      show_contact_name: this.singleSpaceData && this.singleSpaceData.config && this.singleSpaceData.config.show_contact_name ? this.singleSpaceData.config.show_contact_name : false,
      show_contact_phone: this.singleSpaceData && this.singleSpaceData.config && this.singleSpaceData.config.show_contact_phone ? this.singleSpaceData.config.show_contact_phone : false,
      show_external_url: this.singleSpaceData && this.singleSpaceData.config && this.singleSpaceData.config.show_external_url ? this.singleSpaceData.config.show_external_url : false,
      show_name_summary: this.singleSpaceData && this.singleSpaceData.config && this.singleSpaceData.config.show_name_summary ? this.singleSpaceData.config.show_name_summary : false,
      show_published_date: this.singleSpaceData && this.singleSpaceData.config && this.singleSpaceData.config.show_published_date ? this.singleSpaceData.config.show_published_date : false,
    };
  }

  updateSpaceFormInit() {
    this.updateSpaceForm = this.fb.group({
      category_id: [this.singleSpaceData.category && this.singleSpaceData.category.uuid ? this.singleSpaceData.category.uuid : '', [Validators.required]],
      title: [this.singleSpaceData.title, [Validators.required, Validators.maxLength(40)]],
      summary: [this.singleSpaceData.summary],
      published_date: [this.singleSpaceData.published_date, [Validators.compose([DateValidator.dateVaidator])] ],
      external_url: [this.singleSpaceData.external_url, [Validators.pattern(this.urlPattern)]],
      author: [this.singleSpaceData.author, [Validators.maxLength(40)]],
      presented_by: [this.singleSpaceData.presented_by, [Validators.maxLength(40)]],
      contact_name: [this.singleSpaceData.contact_name, [Validators.maxLength(40)]],
      contact_phone: [this.singleSpaceData.contact_phone, [Validators.pattern(/^[0-9]{10}$/)]],
      contact_email: [this.singleSpaceData.contact_email, [Validators.email,
        Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')]],
      address: [this.singleSpaceData.address, [Validators.maxLength(40)]],
      image: [''],
      audio: [''],
      space_type: [this.singleSpaceData.space_type, [Validators.required]],
    });
    // if ($(this.publishedDate.nativeElement)) {
    //   $(this.publishedDate.nativeElement).datepicker({
    //     format: 'yyyy-mm-dd'
    //   });
    // }
  }

  submit(value) {
    if (!this.updateSpaceForm.valid || this.uploadErr) {
      this.isSubmitting = true;
      this.scrollHelper.scrollToFirst('has__error');
      return;
    }
    if (this.isSubmitted) {
      return;
    }
    this.isSubmitted = true;
    this.resetErrors();
    const data = value;
    data.country_code = this.selectedCountry.alpha_code;
    console.log(data.published_date);
    if ( data.published_date) {
      data.published_date = moment(data.published_at, 'YYYY-MM-DD');
    }
    // Space config
    data.show_contact_name = this.spaceConfig.show_contact_name;
    data.show_contact_email = this.spaceConfig.show_contact_email;
    data.show_contact_phone = this.spaceConfig.show_contact_phone;
    data.show_address = this.spaceConfig.show_address;
    data.show_external_url = this.spaceConfig.show_external_url;
    data.show_published_date = this.spaceConfig.show_published_date;

    this.updateSpace(data);
  }

  resetErrors() {
    this.errorMsg = undefined;
    this.errors = [];
  }

  updateSpace(data) {
    let formData;
    formData = data;
    formData = this.helperService.updateJsonFormat(formData);
    this.memberService.updateMemberSpace({
      Authorization: this.accessToken,
      id: this.singleSpaceData.uuid,
      body: formData
    }).subscribe((response: any) => {
      this.resetForm();
      this.successMsg = 'Space was successfuly updated.';
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      // this.scrollHelper.scrollToFirst('alert-success');
      setTimeout(() => {
        const responseData = response && response.data ? response.data : undefined;
        this.updateSpaceEmit.emit(responseData);
      }, 2000);
    }, err => {
      this.handleErrors(err);
    });
  }

  resetForm() {
    this.isSubmitted = false;
    this.isSubmitting = false;
  }

  resetFormValues() {
    this.updateSpaceForm.reset({
      category_id: '',
      title: '',
      summary: '',
      published_date: '',
      external_url: '',
      author: '',
      presented_by: '',
      contact_name: '',
      contact_phone: '',
      contact_email: '',
      address: '',
      image: '',
      audio: '',
      space_type: '2D'
    });
  }

  handleErrors(err) {
    if (err.error && err.error.errors) {
      this.errors = err.error.errors;
    } else if (err.error && err.error.error) {
      this.errorMsg = err.error.error;
    } else {
      this.errorMsg = 'There was error while creating space.';
    }
    this.isSubmitted = false;
    this.isSubmitting = false;
    this.scrollHelper.scrollToFirst('alert-danger');
    setTimeout(() => {
      this.resetErrors();
    }, 5000);
  }

  resetErrorValues() {
    this.errorMsg = undefined;
    this.successMsg = undefined;
    this.imageData = undefined;
    this.selectedFile = undefined;
    this.isSubmitting = false;
    this.isSubmitted = false;
    this.uploadErr = undefined;
    if (this.imageFile) {
      this.imageFile.nativeElement.value = '';
    }
    // Audio
    this.audioLoader = false;
    this.audioUploadErr = undefined;
    this.selectedAudioFile = undefined;
    this.audioData = undefined;
    if (this.audioFile) {
      this.audioFile.nativeElement.value = '';
    }
  }

  ngAfterViewChecked() {
    this.scrollHelper.doScroll();
  }

  closeUpdateModal() {
    setTimeout(() => {
      this.closeUpdateSpaceEmit.emit(true);
    }, 500);
  }

  removeAudioFile() {
    this.memberService.deleteAudioSpace({
      Authorization: this.accessToken,
      id: this.singleSpaceData.uuid
    }).subscribe((res) => {
      this.updateSpaceForm.controls.audio.setValue('');
      if (this.audioFile) {
        this.audioFile.nativeElement.value = '';
      }
      this.audioLoader = false;
      this.audioUploadErr = undefined;
      this.selectedAudioFile = undefined;
      this.audioData = undefined;
      this.audioText = 'Choose File';
    });
  }

  configChange(value) {
    this.spaceConfig[value] = !this.spaceConfig[value];
  }

  // removeImageFile() {
  //   this.createSpaceForm.controls.image.setValue('');
  // }

}
